<template>
  <div class="wrapper">
    <!-- @click="handleSubmit" -->
    <button type="button" id="sendCodePrivacy" class="btn btn-default" :class="{'is-text': type==='text', 'is-info': type==='info'}">
      <img v-if="isShow" class="icon" :src="icon[0].url" />
      <img v-else class="icon" :src="icon[1].url" />
      <!--      <span>隐私</span>-->
    </button>

    <div id="captcha"></div>
   
  </div>
</template>

<script>
import {Dialog} from "vant";
import api from '@/api'


export default {
  name: "PrivacyButton",
  props: {
    type: {
      type: String,
      default: 'btn'
    },
    reload:{
      type:Boolean,
      default: true
    }
  },
  data() {
    return {
      token: "",
      isShow: true,
      iconUrl: require("@/assets/icons/icon-visible.png"),
      icon: [{
        url: require("@/assets/icons/icon-invisible.png")
      },{
        url: require("@/assets/icons/icon-visible.png")
      }],
      isAllowNvc: true,
      isVerificationCodeLayer: false,
      captcha:null

    }
  },
 
  created() {
    this.token = this.$store.state.token;
     this.getPrivacyProtectionStatus();
  },
  mounted() {
     this.initAWSC();
  },
  methods: {
    async handleSubmit () {
      if (!this.isAllowNvc) {
        return;
      }

      // 人机验证
      if (!window.nvc) return;

      // this.$loading.show();
      window.nvc.getNVCValAsync(async (nvcVal) => {
        // console.log(nvcVal)
        // 无痕验证获取nvc data，用无痕验证模式调是否用开启隐私保护接口
        const request = this.getRequest("AliYunAfsNvc", nvcVal);
        await this.updatePrivacyStatus(request);
      });

    },
    async getPrivacyProtectionStatus () {
      const token = this.$store.state.token;
      const { success, data, errMsg } = await api.changePrivacyProtectionIsOpen(token)
      if(success) {
        //data是隐私保护状态,true是开启,false为关闭
        this.isShow = data;
        this.$store.commit("SET_IS_MASK_VALUE", data);
      } else {
        console.log(errMsg)
        Dialog.alert({
          message: errMsg
        })
        // this.$alert.show(errMsg)
      }
    },


    getInstance(instance) {
      this.captcha = instance
    },
    fail(error) {
      console.error(error);
      this.isAllowNvc = false
    },
    async success(captchaVerifyParam) {
      console.log(captchaVerifyParam,'captchaVerifyParam');
      this.isAllowNvc = true
      this.isVerificationCodeLayer = false;
      // this.$loading.show();
      const request = this.getRequest("AliYunAfsNc", captchaVerifyParam);
      await this.updatePrivacyStatus(request);
    },

    initAWSC () {
      if (!window.initAliyunCaptcha) return
       window.initAliyunCaptcha({
    // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      SceneId: "5v4v21th",
      // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
      mode: "popup",
      // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      element: "#captcha",
      // 触发验证码弹窗或无痕验证的元素
      button: "#sendCodePrivacy",
      // 验证码验证通过回调函数
      success: this.success,
      // 验证码验证不通过回调函数
      fail: this.fail,
      // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
      getInstance: this.getInstance,
      // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。兼容历史参数名。
      slideStyle: {
        width: 260,
        height: 40,
      },
      // ...其他参数，参考initAliyunCaptcha参数说明
    });

    },
    async updatePrivacyStatus(request) {
      if (!this.isAllowNvc) return;
      const { success, data, errMsg } = await api.updateUserPrivacyProtection(request);
      console.log('update reselut',data)
      if (!success) {
        Dialog.alert({
          message: errMsg
        })
        this.initAWSC();
      } else {
        this.$store.commit("SET_IS_MASK_VALUE", !this.isShow);
        this.isShow =!this.isShow;
        this.$emit("switch", true);
        this.initAWSC();

      }
    },
    getRequest (codeType, codeValue) {
      return {
        userName: this.token,
        isOpenPrivacyProtection: !this.isShow,
        codeType: codeType,
        codeValue: codeValue,
        sceneId: '5v4v21th',
				captchaVerifyParam: codeValue,
      };
    }
  }
}
</script>

<style scoped lang="less">

.btn {
  height: 36px;
  border: none;
  border-radius: 0;
  padding: 0 12px 0 39px;
  position: relative;
  font-size: 16px;
  &:focus {
    outline: none;
  }
  &.btn-default {
    background-color: #FFFFFF;
    border: 1px solid #cccccc;
    &.is-text {
      height: auto;
      padding: 0;
      background-color: transparent;
      border: none;
    }
    &.is-info {
      height: 25px;
      background-color: #FFFFFF;
      border: 1px solid #cccccc;
      & .icon {
        height: 20px;
        width: 20px;
      }
    }
  }
  & .icon {
    height: 22px;
    width: 22px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 12px;
  }
}
.verification-wrapper{
  height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
}
#captcha {
  position: relative;
  margin-top: 40px;
  .nc_wrapper {
    width: 100%;
    background-color: #0f254c;
  }
}
.title {
  margin: 10px auto 0;
  text-align: center;
  font-size: 30px;
}
</style>